module.exports = __webpack_public_path__ + "img/83.2c71c2a6.png";